import React, { Component } from 'react';

import './style.css';


export default class Form extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    const title = this.props.title ? <div className='form__title'>{this.props.title}</div> : null;
    return (
      <form className={'form ' + classes} method='POST' ref='form'>
        {title}
        <div className='form__success-message'>{this.props.successMessage}</div>
        {this.props.children}
      </form>
    );
  }
}


// WEBPACK FOOTER //
// ./src/blocks/form-blocks/Form.js